import { Mapper } from '@data/base/mapper';
import { CupomEntity } from '@domain/dto/reserva/reserva-cupom-get.dto';

export class CupomMapper extends Mapper<CupomEntity> {
  fromJson(param: any): CupomEntity {
    return param;
  }
}
